module.exports = __webpack_public_path__ + "static/media/user-green.2b013b04.svg";